import type { StatusFor } from '@/modules/projects/components/Workbench/coverage'
import { EmptyLaneStrip } from '@/modules/projects/components/Workbench/EmptyLaneStrip'
import { MapCell } from '@/modules/projects/components/Workbench/MapCell'
import { MapSpan } from '@/modules/projects/components/Workbench/MapSpan'
import {
  laneNumberOf,
  type MapLane,
} from '@/modules/projects/components/Workbench/map'
import {
  GRID,
  MONTH_GAP,
  TRACK_HEIGHT,
  YEAR_GAP,
} from '@/modules/projects/components/Workbench/mapLayout'
import type {
  Highlight,
  MapActions,
} from '@/modules/projects/components/Workbench/mapView'
import { cn } from '@/utils'

export const YearRows = ({
  lane,
  choosing,
  openStatementId,
  highlight,
  statusFor,
  actions,
}: {
  lane: MapLane
  choosing: boolean
  openStatementId: string | null
  highlight: Highlight
  statusFor: StatusFor
  actions: MapActions
}) => {
  if (lane.years.length === 0) {
    return <EmptyLaneStrip lane={lane} choosing={choosing} actions={actions} />
  }

  // Bars sit on the row's tracks and empty months on the first one, so a month is either a bar
  // running through it or a place to file pages, never both.
  return (
    <div className={YEAR_GAP}>
      {lane.years.map((row) => (
        <div
          key={row.year}
          className={cn('grid items-center', MONTH_GAP)}
          style={{
            gridTemplateColumns: GRID,
            gridTemplateRows: `repeat(${row.trackCount}, ${TRACK_HEIGHT})`,
          }}
        >
          <span
            className="text-xs font-medium tabular-nums text-foreground"
            style={{ gridColumn: 1, gridRow: 1 }}
          >
            {row.year}
          </span>
          {row.cells
            .filter((cell) => cell.views.length === 0)
            .map((cell) => (
              <MapCell
                key={cell.monthIndex}
                cell={cell}
                gridRow={1}
                laneLabel={lane.label}
                choosing={choosing}
                highlight={highlight}
                actions={actions}
              />
            ))}
          {row.spans.map((span) => (
            <MapSpan
              key={span.view.statement.id}
              span={span}
              laneLabel={lane.label}
              laneNumber={laneNumberOf(lane)}
              choosing={choosing}
              openStatementId={openStatementId}
              highlight={highlight}
              statusFor={statusFor}
              actions={actions}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
